<div class="support-ticket-form-dialog">

  <!-- Dialog header -->
  <div class="dialog-header">
    <div class="dialog-title-wrap">
      <h2 mat-dialog-title class="dialog-title">{{ titleText }}<span class="dialog-required-marker">*</span><span
          class="dialog-required-text">{{ 'ime.indicates.required.field' | translate }}</span></h2>
    </div>
    <button type="button" class="close-btn" (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="dialog-header-divider"></div>

  <mat-dialog-content class="dialog-body">

    <form [formGroup]="ticketForm" autocomplete="off">

      <!-- ============================= USERS DETAILS ============================= -->
      <h4 class="section-heading">{{'ime.user.details'|translate }}</h4>

      <div class="form-grid">

        <!-- Currently logged in org and stockroom (readonly) -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.current.org.stockroom'|translate }}</div>
          <mat-form-field class="w-100 support-ticket-field readonly-field">
            <input matInput type="text" formControlName="currentOrgStockroom" placeholder="Current Org - Stockroom" />
          </mat-form-field>
        </div>

        <!-- Reporting User Id (readonly, shows email) -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.reporting.user.id'|translate }}</div>
          <mat-form-field class="w-100 support-ticket-field readonly-field">
            <input matInput type="text" formControlName="reportingUserId" placeholder="Current User Id" />
          </mat-form-field>
        </div>

        <!-- Org Name (searchable) -->
        <div class="form-field">
          <div class="mat-form-label">{{'organization.name'|translate}} <span class="req">*</span></div>
          <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
            <mat-select #orgSelect formControlName="orgId" (selectionChange)="onOrgChange($event.value)"
              (openedChange)="onOrgPanelOpened($event)" placeholder="Select" disableOptionCentering
              [panelClass]="['support-ticket-select-panel', 'support-ticket-searchable-panel', 'support-ticket-org-stockroom-menu']">
              <div class="select-search-wrap" (click)="$event.stopPropagation()">
                <mat-icon class="select-search-icon">search</mat-icon>
                <input class="select-search-input" type="text" placeholder="Search organization" [value]="orgFilterText"
                  (keydown)="$event.stopPropagation()" (input)="filterOrg($any($event.target).value)">
              </div>
              <div>
                @if (!filteredOrganizations.length) {
                <div class="select-empty">
                  <strong style="opacity: 0.5"> {{'no.search.result'|translate}} </strong>
                </div>
                }
                @for (org of filteredOrganizations; track org) {
                <mat-option [value]="org.id || org.organizationId || org.orgId">
                  {{ org.orgName || org.organizationName || org.name }}
                </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Stockroom (searchable) -->
        <div class="form-field">
          <div class="mat-form-label">{{'stockroom'|translate}} <span class="req">*</span></div>

          <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
            <mat-select formControlName="stockroomId" (openedChange)="onStockroomPanelOpened($event)"
              placeholder="Select" disableOptionCentering
              [panelClass]="['support-ticket-select-panel', 'support-ticket-searchable-panel', 'support-ticket-org-stockroom-menu']">
              <div class="select-search-wrap" (click)="$event.stopPropagation()">
                <mat-icon class="select-search-icon">search</mat-icon>
                <input class="select-search-input" type="text" placeholder="Search stockroom"
                  [value]="stockroomFilterText" (keydown)="$event.stopPropagation()"
                  (input)="filterStockroom($any($event.target).value)">
              </div>
              <div>
                @if (!filteredStockrooms.length) {
                <div class="select-empty">
                  <strong style="opacity: 0.5"> {{'no.search.result'|translate}} </strong>
                </div>
                }
                @for (sr of filteredStockrooms; track sr) {
                <mat-option [value]="sr.id || sr.stockroomId">
                  {{ sr.stockroomName || sr.name }}
                </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Are you submitting for -->
        <div class="form-field">
          <label class="mat-form-label">{{'ime.are.you.submitting.for'|translate}}</label>
          <mat-radio-group class="support-ticket-radio-group" formControlName="submittingFor"
            (change)="onSubmittingForChange($event.value)">
            <mat-radio-button value="MYSELF">Myself</mat-radio-button>
            <mat-radio-button value="OTHERS">Others</mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Location -->
        <div class="form-field">
          <div class="mat-form-label">{{'location'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="location" placeholder="Select" disableOptionCentering
              panelClass="support-ticket-select-panel">
              @for (loc of locations; track loc) {
              <mat-option [value]="loc.id || loc.locationId">
                {{ loc.locationName }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

      </div>

      <!-- "Others" conditional block -->
      <div class="others-panel" [class.others-panel-hidden]="ticketForm.get('submittingFor')?.value !== 'OTHERS'">

        <div class="others-field">
          <div class="mat-form-label">{{'ime.select.user.id'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select [value]="null" (selectionChange)="onForUserChange($event.value)"
              (openedChange)="onForUserPanelOpened($event)" placeholder="Select" disableOptionCentering
              [panelClass]="['support-ticket-select-panel', 'support-ticket-searchable-panel']">
              <div class="select-search-wrap" (click)="$event.stopPropagation()">
                <mat-icon class="select-search-icon">search</mat-icon>
                <input class="select-search-input" type="text" placeholder="Search user" [value]="userIdFilterText"
                  (keydown)="$event.stopPropagation()" (input)="filterUsersForOthers($any($event.target).value)">
              </div>
              <div>
                @if (!filteredUsersForOthers.length) {
                <div class="select-empty">
                  <strong style="opacity: 0.5"> {{'no.search.result'|translate}} </strong>
                </div>
                }
                @for (u of filteredUsersForOthers; track u) {
                <mat-option [value]="getUserId(u)">
                  {{ getUserDisplayName(u) }}
                  @if (getUserEmail(u)) {
                  <ng-container>({{ getUserEmail(u) }})</ng-container>
                  }
                </mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="others-table-label">{{'ime.data.of.the.selected.user.id'|translate}}</div>
        <table class="others-table">
          <thead>
            <tr>
              <th>{{'ime.sl.no'|translate | titlecase}}</th>
              <th>{{'user.id'|translate| titlecase}}</th>
              <th>{{'email'|translate| titlecase}}</th>
              <th class="actions-col">{{'actions'|translate | titlecase}}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of selectedOtherUsers; track row; let i = $index) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ row.name }}</td>
              <td>{{ row.email }}</td>
              <td class="actions-col">
                <button type="button" class="row-delete-btn" (click)="removeOtherUser(i)" aria-label="Remove user">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </tr>
            }
            @if (!selectedOtherUsers.length) {
            <tr>
              <td colspan="4" class="empty-row">{{'ime.no.user.selected'|translate}}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="form-grid mt-3">

        <!-- Application * -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.application'|translate}} <span class="req">*</span></div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="application" (selectionChange)="onApplicationChange($event.value)"
              placeholder="Select" disableOptionCentering panelClass="support-ticket-select-panel">
              @for (a of applicationOptions; track a) {
              <mat-option [value]="a">{{ a }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Functional Area (multi-select; list depends on User Interface selection) -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.functional.area'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="functionalArea" multiple placeholder="Select" disableOptionCentering
              (openedChange)="onFunctionalAreaPanelOpened($event)"
              [panelClass]="['support-ticket-select-panel', 'support-ticket-searchable-panel', 'support-ticket-multiple-panel']">
              <mat-select-trigger>{{ getMultiSelectLabel('functionalArea') }}</mat-select-trigger>
              <div class="select-search-wrap" (click)="$event.stopPropagation()">
                <mat-icon class="select-search-icon">search</mat-icon>
                <input class="select-search-input" type="text" placeholder="Search functional area"
                  [value]="functionalAreaFilterText" (keydown)="$event.stopPropagation()"
                  (input)="filterFunctionalArea($any($event.target).value)">
              </div>
              <div>
                @if (!filteredFunctionalAreaOptions.length) {
                <div class="select-empty">
                  <strong style="opacity: 0.5"> {{'no.search.result'|translate}} </strong>
                </div>
                }
                @for (f of filteredFunctionalAreaOptions; track f) {
                <mat-option [value]="f">{{ f }}</mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- User Interface * (single-select: Web / Mobile / Both) -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.user.interface'|translate}} <span class="req">*</span></div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="userInterface" (selectionChange)="onUserInterfaceChange($event.value)"
              placeholder="Select" disableOptionCentering panelClass="support-ticket-select-panel">
              @for (ui of userInterfaceOptions; track ui) {
              <mat-option [value]="ui">{{ ui }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Browser -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.browser'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="browser" multiple placeholder="Select" disableOptionCentering
              [panelClass]="['support-ticket-select-panel', 'support-ticket-multiple-panel']">
              <mat-select-trigger>{{ getMultiSelectLabel('browser') }}</mat-select-trigger>
              @for (b of browserOptions; track b) {
              <mat-option [value]="b">{{ b }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- ============================= ISSUE DETAILS ============================= -->
      <h4 class="section-heading">{{'ime.issue.details'|translate}}</h4>

      <div class="form-grid">

        <!-- Issues Occurs for All Users * -->
        <div class="form-field">
          <label class="mat-form-label">{{'ime.issues.occurs.for.all.users'|translate}} <span
              class="req">*</span></label>
          <mat-radio-group class="support-ticket-radio-group"
            [class.invalid-radio]="isInvalid('issueOccursForAllUsers')" formControlName="issueOccursForAllUsers">
            <mat-radio-button [value]="true">Yes</mat-radio-button>
            <mat-radio-button [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="form-grid">
        <!-- Issue Occurred Date * -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.issue.occurred.date'|translate}} <span class="req">*</span></div>
          <mat-form-field class="w-100 support-ticket-field">
            <input matInput readonly class="readonly-date-input" [matDatepicker]="issuePicker"
              formControlName="issueOccurredDate" [max]="maxIssueOccurredDate" (click)="issuePicker.open()" />
            <mat-datepicker-toggle matSuffix [for]="issuePicker"></mat-datepicker-toggle>
            <mat-datepicker #issuePicker></mat-datepicker>
          </mat-form-field>
        </div>

        <!-- Issue Type -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.issue.type'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="issueType" placeholder="Select" disableOptionCentering
              panelClass="support-ticket-select-panel">
              @for (i of issueTypeOptions; track i) {
              <mat-option [value]="i">{{ i }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Scale of Impact -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.scale.of.impact'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="scaleOfImpact" placeholder="Select" disableOptionCentering
              panelClass="support-ticket-select-panel">
              @for (s of scaleOfImpactOptions; track s) {
              <mat-option [value]="s">{{ s }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Module/Screen (searchable, multi-select from static list) -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.module.screen'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field">
            <mat-select formControlName="moduleScreens" multiple (openedChange)="onModuleScreenPanelOpened($event)"
              placeholder="Select" disableOptionCentering
              [panelClass]="['support-ticket-select-panel', 'support-ticket-searchable-panel', 'support-ticket-multiple-panel']">
              <mat-select-trigger>{{ getModuleScreenSelectLabel() }}</mat-select-trigger>
              <div class="select-search-wrap" (click)="$event.stopPropagation()">
                <mat-icon class="select-search-icon">search</mat-icon>
                <input class="select-search-input" type="text" placeholder="Search module"
                  [value]="moduleScreenFilterText" (keydown)="$event.stopPropagation()"
                  (input)="filterModuleScreen($any($event.target).value)">
              </div>
              <div>
                @if (!filteredModuleScreenOptions.length) {
                <div class="select-empty">
                  <strong style="opacity: 0.5"> {{'no.search.result'|translate}} </strong>
                </div>
                }
                @for (m of filteredModuleScreenOptions; track m) {
                <mat-option [value]="m.id">{{ m.name }}</mat-option>
                }
              </div>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="form-field"></div>

      </div>

      <!-- ============================= DEFECT DETAILS ============================= -->
      <h4 class="section-heading">{{'ime.defect.details'|translate}}</h4>

      <div class="form-grid">
        <!-- Defect Title * -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.defect.title'|translate}} <span class="req">*</span></div>
          <mat-form-field class="w-100 support-ticket-field">
            <input matInput type="text" formControlName="defectTitle" maxlength="500"
              placeholder="{{'ime.enter.a.short.title'|translate}}" />
          </mat-form-field>
        </div>

        <!-- Defect Description * -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.defect.description'|translate}} <span class="req">*</span></div>
          <mat-form-field class="w-100 support-ticket-field support-ticket-textarea">
            <textarea matInput rows="4" maxlength="5000" formControlName="defectDescription"
              placeholder="{{'ime.tell.us.about.your.use.case'|translate}}"></textarea>
          </mat-form-field>
        </div>

        <!-- Defect Steps -->
        <div class="form-field">
          <div class="mat-form-label">{{'ime.defect.steps.to.reproduce'|translate}}</div>
          <mat-form-field class="w-100 support-ticket-field support-ticket-textarea">
            <textarea matInput rows="4" maxlength="5000" formControlName="defectStepsToReproduce"
              placeholder="{{'ime.defect.steps.to.reproduce.placeholder'|translate}}"></textarea>
          </mat-form-field>
        </div>
      </div>

      <!-- Screenshot upload (multi-file: dropzone left, list right) -->
      <div class="form-field full-width">
        <label class="mat-form-label">{{'ime.screenshots.of.the.defect'|translate}}</label>

        <div class="upload-grid">
          <!-- Left: dropzone (click + drop disabled once MAX_FILES reached) -->
          <div class="file-dropzone" [class.is-full]="isUploadFull"
            [attr.aria-disabled]="isUploadFull ? 'true' : 'false'" (click)="onDropzoneClick(fileInput)"
            (dragover)="onDropzoneDragOver($event)" (drop)="onFileDrop($event)">
            <mat-icon class="dropzone-icon">{{ isUploadFull ? 'block' : 'cloud_upload' }}</mat-icon>
            @if (!isUploadFull) {
            <div class="dropzone-text">
              {{'ime.drag.your.files.or'|translate}} <span class="browse-link">{{'ime.browse'|translate}}</span>
            </div>
            }
            @if (isUploadFull) {
            <div class="dropzone-text dropzone-text-disabled">
              {{'ime.max.files.uploaded'|translate}}
            </div>
            }
            <small class="dropzone-hint">
              Up to {{ MAX_FILES }} files - Max {{ MAX_FILE_SIZE_MB }} MB each - pdf, jpeg, jpg, mp4, doc, docx, txt,
              xls and xlsx
            </small>
            @if (attachedFiles.length) {
            <small class="dropzone-count">
              {{ attachedFiles.length }} / {{ MAX_FILES }} attached
            </small>
            }
            <input #fileInput type="file" hidden multiple [attr.accept]="ACCEPT_ATTR" [disabled]="isUploadFull"
              (change)="onFileSelected($event)" />
          </div>

          <!-- Right: file list with remove option -->
          @if (attachedFiles.length) {
          <div class="file-list">
            <div class="file-list-header">{{'ime.attached.files'|translate}}</div>
            @for (f of attachedFiles; track f; let i = $index) {
            <div class="file-row">
              <mat-icon class="file-row-icon">{{ fileIconFor(f) }}</mat-icon>
              <div class="file-row-meta">
                <div class="file-row-name" [title]="f.name">{{ f.name }}</div>
                <div class="file-row-size">{{ fileSizeLabel(f.size) }}</div>
              </div>
              <button type="button" class="file-row-remove" (click)="removeFile(i, $event)" aria-label="Remove file">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            }
          </div>
          }
          @if (!attachedFiles.length) {
          <div class="file-list file-list-empty">
            <div class="file-list-header">{{'ime.attached.files'|translate}}</div>
            <div class="file-list-empty-text">{{'ime.no.files.attached.yet'|translate}}</div>
          </div>
          }
        </div>
      </div>

    </form>

  </mat-dialog-content>

  <!-- Submit -->
  <div class="dialog-footer">
    <button type="button" class="submit-btn" (click)="submit()" [disabled]="submitting">
      @if (!submitting) {
      <span>{{'submit'|translate}}</span>
      }
      @if (submitting) {
      <mat-spinner diameter="18" class="d-inline-block align-middle"></mat-spinner>
      }
    </button>
  </div>

</div>